import axios from 'axios';

// Research if I can make this a functional component that can have access to the session context
export default axios.create({
        baseURL: process.env.REACT_APP_API_URL
    });